/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import BaseClass from 'components/BaseClass';
import { wrapComponent } from 'utils/framework';
import Empty from 'constants/empty';
import { Container } from 'components/ui';
import contentConstants from 'constants/content';
import ComponentList from 'components/Content/ComponentList';
import ShopYourStoreBindings from 'analytics/bindingMethods/pages/ShopYourStore/ShopYourStoreBindings';
import helpersUtils from 'utils/Helpers';
const { deferTaskExecution } = helpersUtils;
import { LANDING_PAGE } from 'constants/ShopYourStore';

const { CONTEXTS } = contentConstants;

class ShopSameDayMain extends BaseClass {
    openShippingDeliveryLocationTimeOut;

    componentDidMount() {
        const {
            isInitialized, sameDayAvailable, hasPreferredZipCode, showShippingDeliveryLocationModal, showInterstice, fetchShopSameDay
        } =
            this.props;

        if (!hasPreferredZipCode) {
            deferTaskExecution(() => {
                showInterstice(true);
            });
            const fn = () => {
                showInterstice(false);
                showShippingDeliveryLocationModal();
            };

            // If a preferred zip code is not available at page load,
            // wait N seconds before triggering the Shipping Delivery Location modal.
            this.openShippingDeliveryLocationTimeOut = setTimeout(fn, LANDING_PAGE.TIMEOUT);
        } else if (!isInitialized) {
            fetchShopSameDay();
        } else if (isInitialized) {
            // Trigger page load tracking for SPA
            ShopYourStoreBindings.shopSameDayPageLoad(sameDayAvailable);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            pageKey, sameDayAvailable, hasPreferredZipCode, isInitialized, fetchShopSameDay, showShippingDeliveryLocationModal
        } = this.props;

        if (pageKey !== prevProps.pageKey) {
            fetchShopSameDay();
        }

        // If the preferred zip code becomes available after page load:
        // - Clear the timeout that would trigger the Shipping Delivery Location modal
        // - Dispatch an action to close the modal in case it's already open
        if (!prevProps.hasPreferredZipCode && hasPreferredZipCode) {
            clearInterval(this.openShippingDeliveryLocationTimeOut);
            showShippingDeliveryLocationModal(null, false);
        }

        // Trigger page load tracking for full (hard) page load
        if (!prevProps.isInitialized && isInitialized) {
            ShopYourStoreBindings.shopSameDayPageLoad(sameDayAvailable);
        }
    }

    componentWillUnmount() {
        clearInterval(this.openShippingDeliveryLocationTimeOut);
    }

    render() {
        const { isInitialized, content } = this.props;

        if (!isInitialized) {
            return null;
        }

        return (
            <Container
                key='ShopSameDayMain'
                paddingTop={[4, 5]}
            >
                <ComponentList
                    items={content}
                    context={CONTEXTS.CONTAINER}
                />
            </Container>
        );
    }
}

ShopSameDayMain.propTypes = {
    isInitialized: PropTypes.bool.isRequired,
    pageKey: PropTypes.string,
    hasPreferredZipCode: PropTypes.bool,
    showInterstice: PropTypes.func,
    showShippingDeliveryLocationModal: PropTypes.func,
    fetchShopSameDay: PropTypes.func.isRequired
};

ShopSameDayMain.propTypes = {
    isInitialized: false,
    pageKey: '',
    hasPreferredZipCode: true,
    showInterstice: Empty.Function,
    showShippingDeliveryLocationModal: Empty.Function,
    fetchShopSameDay: Empty.Function
};

export default wrapComponent(ShopSameDayMain, 'ShopSameDayMain', true);
